import React from 'react';
import TemplateCollections from '../../components/crm/TemplateCollections';

// Operations starts with one empty section; staff add their own from the page.
const DEFAULT_OPERATIONS_SECTIONS = [{ id: 'general', label: 'General', items: [] }];

const OPERATIONS_CONFIG = {
  title: 'Operations Materials',
  pillar: 'Operations',
  structureId: 'operations',
  defaultSections: DEFAULT_OPERATIONS_SECTIONS,
  backTo: '/crm/templates',
  accent: {
    tabActive: 'bg-blue-600',
    spinner: 'border-blue-600',
    button: 'bg-blue-600 hover:bg-blue-700',
  },
  sectionPlaceholder: 'e.g. Checklists',
  itemPlaceholder: 'e.g. Project Handoff Checklist',
  showCanvaLink: true,
};

const OperationsCollections = () => <TemplateCollections config={OPERATIONS_CONFIG} />;

export default OperationsCollections;
